var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.334 58.3334H11.6673C10.1202 58.3334 8.63649 57.7188 7.54253 56.6248C6.44857 55.5309 5.83398 54.0471 5.83398 52.5001V17.2463C5.89941 15.7436 6.54276 14.3243 7.62971 13.2846C8.71666 12.245 10.1632 11.6653 11.6673 11.6668H58.334C59.8811 11.6668 61.3648 12.2813 62.4588 13.3753C63.5527 14.4693 64.1673 15.953 64.1673 17.5001V52.5001C64.1673 54.0471 63.5527 55.5309 62.4588 56.6248C61.3648 57.7188 59.8811 58.3334 58.334 58.3334ZM11.6673 22.9484V52.5001H58.334V22.9484L35.0007 38.5001L11.6673 22.9484ZM14.0007 17.5001L35.0007 31.5001L56.0007 17.5001H14.0007Z",
    fill: "#455A64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7d055e212a31c1b379e0e1b3751f4fed.svg";
export { ForwardRef as ReactComponent };